export default __webpack_public_path__ + "static/media/presentation.5e093ac3.pptx";